import { formatDateTime } from "../../users/adminUserFormatters";
import WeatherHealthBadge from "./WeatherHealthBadge";

const WeatherSourceRunHistory = ({ runs }) => {
  if (!runs?.length) {
    return (
      <div className="admin-dash__card">
        <h2 className="admin-dash__card-title">Recent runs</h2>
        <p className="weather-source-detail__empty">No ingestion or health runs recorded yet.</p>
      </div>
    );
  }

  return (
    <div className="admin-dash__card admin-dash__card--wide">
      <h2 className="admin-dash__card-title">Recent runs</h2>
      <div className="admin-data-health-table-wrap">
        <table className="admin-data-health-table">
          <thead>
            <tr>
              <th scope="col">Time</th>
              <th scope="col">Source</th>
              <th scope="col">Run type</th>
              <th scope="col">Status</th>
              <th scope="col">Found</th>
              <th scope="col">Inserted</th>
              <th scope="col">Updated</th>
              <th scope="col">Error</th>
            </tr>
          </thead>
          <tbody>
            {runs.map((run) => (
              <tr key={run.runId}>
                <td>{formatDateTime(run.startedAt || run.completedAt)}</td>
                <td>{run.sourceKey}</td>
                <td>{run.runType}</td>
                <td>
                  <WeatherHealthBadge status={run.status === "success" ? "fresh" : run.status} />
                </td>
                <td>{run.recordsFound ?? "—"}</td>
                <td>{run.recordsInserted ?? "—"}</td>
                <td>{run.recordsUpdated ?? "—"}</td>
                <td>{run.errorMessage || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WeatherSourceRunHistory;
